export const ANGOLAN_IBAN_PREFIX = 'AO06';
